import { Control, Controller } from 'react-hook-form'
import AutocompleteAsyncMui, { TAutocompleteAsyncMui } from './AutocompleteAsync.mui'

export type TAutocompleteAsyncMuiHookForm<T> = Omit<TAutocompleteAsyncMui<T>, 'onChange' | 'value'> & {
  fieldName: string
  control: Control<any, any>
  errors?: string
  additionalOnChange?: (value: string) => void
}

export default function AutocompleteAsyncMuiHookForm<T>({
  fieldName,
  control,
  onSelect,
  additionalOnChange,
  ...props
}: Readonly<TAutocompleteAsyncMuiHookForm<T>>) {
  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => {
        const { onChange, ...restField } = field
        return (
          <AutocompleteAsyncMui<T>
            onSelect={onSelect}
            {...restField}
            {...props}
            onChange={(value) => {
              onChange(value)
              additionalOnChange?.(value)
            }}
          />
        )
      }}
    />
  )
}
